(function () {
	'use strict';

	angular.module('app.core').config([
		'$stateProvider',
		function ($stateProvider) {
			$stateProvider
				.state('neighbourSection', {
					url: '/:langcode/n', //n is required for SEO
					params: {
						langcode: {
				            value: ['$translate', function ($translate) {
                                return $translate.use();
                            }]
						}
					},
					abstract: true,
					templateUrl: 'app/neighbourhood/views/neighbourhood.html',
					controller: 'NeighbourhoodController',
					resolve: {
						lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
							return lazyLoadSvc.load($transition$, 'neighbourhood');
						}],

						translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
							$translatePartialLoader.addPart("analysis_houseOpportDetail");
							$translatePartialLoader.addPart("analysis_layout");
							$translatePartialLoader.addPart("analysis_value");
							return $translate.refresh();
						}]
					}
				})
				.state('neighbourSection.details', {
					url: '/:neighbourhood/:id',
					templateUrl: 'app/neighbourhood/views/neighbourhoodDetail/neighbourhoodDetail.html',
					controller: 'NeighbourhoodDetailController',
					params: {
						neighbourhood: {
							value: null,
							dynamic: true
						},
						id: {
							value: null,
							dynamic: true
						}
					},
					resolve: {

						getNeighbourhoodById: [
							'geoApi',
							'$transition$',
							'$q',
							function (geoApi, $transition$, $q) {
								var deferred = $q.defer();
								var tempId = +$transition$.params().id;
								var res = geoApi.getById({ districtId: tempId, countyId: 0, cityId: 0, countryId: 1, level: 3 });
								res.$promise.then(
									function (result) {
										deferred.resolve(result);
									},
									function (err) {
										deferred.reject(err);
									}
								);
								return deferred.promise;
							}
						],

						titleCase: ['getNeighbourhoodById', function (getNeighbourhoodById) {
							return getNeighbourhoodById && getNeighbourhoodById.features ? getNeighbourhoodById.features[0].properties.District : "";
						}],

						titleCase2: ['getNeighbourhoodById', function (getNeighbourhoodById) {
							return getNeighbourhoodById && getNeighbourhoodById.features ? (getNeighbourhoodById.features[0].properties.City + ' ' + getNeighbourhoodById.features[0].properties.County) : "";
						}],
						title: ['$translate', function ($translate) {
							return $translate('c_nbr1').then(function (res) {
								return res;
							});
						}],
						description: ['$translate', function ($translate) {
							return $translate('c_nbr2').then(function (res) {
								return res;
							});
						}],


						translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
							$translatePartialLoader.addPart('neighbourhood_detail');
							return $translate.refresh();
						}]
					},
					metaTags: {
						title: '{{titleCase2}} {{titleCase}} {{title}}',
						description: '{{titleCase2}} {{titleCase}} {{description}}',
						robots: 'noindex, nofollow',
						properties: {
							'og:image': 'http://www.endeksa.com/og_image3.png',
							'og:image:secure_url': 'https://www.endeksa.com/og_image3.png',
							'og:type': 'website'
						}
					}
				})
				/* .state('neighbourSection.details.explore', {
					views: {
						mapData: {
							templateUrl:
								'app/neighbourhood/views/neighbourhoodDetail/neighbourhoodDetailExplore/neighbourhoodDetailExplore.html',
							controller: 'NeighbourhoodDetailExploreController'
						}
					},
					metaTags: {
						title: '{{titleCase2}} {{titleCase}} {{title}}',
						description: '{{titleCase2}} {{titleCase}} {{description}}',
						robots: 'noindex, nofollow',
						properties: {
							'og:image': 'http://www.endeksa.com/og_image3.png',
							'og:image:secure_url': 'https://www.endeksa.com/og_image3.png',
							'og:type': 'website'
						}
					}
				}); */
		}
	]);

})();
